import { ImageAsset } from 'lib/shop/types';
import Image from 'next/image';

export default function ArticleHeaderImage({
  alt,
  image,
  wideImage,
}: {
  alt?: string;
  image?: ImageAsset | null;
  wideImage?: ImageAsset | null;
}) {
  if (!image && !wideImage) return null;

  if (wideImage) {
    return (
      <>
        {/* Wide image for sm and up */}
        <div className="relative hidden aspect-[16/9] sm:block">
          <Image
            className="w-full"
            alt={alt}
            src={wideImage.url}
            width={wideImage.width ?? 0}
            height={wideImage.height ?? 0}
            layout="responsive"
            priority
          />
        </div>
        {/* Regular hero image for everything else*/}
        {image ? (
          <div className="relative aspect-[1/1] sm:hidden">
            <Image
              className="w-full"
              alt={alt}
              src={image.url}
              width={image.width ?? 0}
              height={image.height ?? 0}
              layout="responsive"
              priority
            />
          </div>
        ) : null}
      </>
    );
  }

  // Square image only...
  return (
    <>
      {image ? (
        <div className="relative aspect-[1/1] sm:aspect-[16/9]">
          <Image
            className="w-full"
            alt={alt}
            src={image.url}
            width={image.width ?? 0}
            height={image.height ?? 0}
            layout="fill"
            objectFit="cover"
            priority
          />
        </div>
      ) : null}
    </>
  );
}
